<!-- <app-upcoming></app-upcoming> -->
<app-topnav></app-topnav>
<app-sidebar></app-sidebar>

<!-- DASHBOARD SLIDER -->
<div class="col-md-12 px-1 d-sm-block d-none custom-mt-10" *ngIf="router.url.includes('home')">
  <div id="DashSlider" class="carousel slide" data-ride="carousel" data-interval="2000">
        <div class="carousel-inner">
          <div class="carousel-item" [ngClass]="{'active' : i==0}" *ngFor="let banner of env.host.desktopBannerList;let i=index">
            <img class="d-block w-100" [src]="banner" alt="">
          </div>
        </div>
  </div>                                    
</div>

<div class="col-md-12 px-1 d-sm-none d-block custom-mt-10" *ngIf="router.url.includes('home')">
  <div id="DashSlider" class="carousel slide" data-ride="carousel" data-interval="2000">
      <div class="carousel-inner">
          <div class="carousel-item" [ngClass]="{'active' : i==0}" *ngFor="let banner of env.host.mobileBannerList;let i=index">
              <img class="d-block w-100" [src]="banner" alt="">
          </div>
        </div>
  </div>                                    
</div>
<!-- end col--> <!-- (DASHBOARD SLIDER) -->


<!-- ======= maina content ======= -->
<div class="main-content">

  <section class="sportbook">
    <div class="container_custom">

      <div class="swiper marketslider">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/aviator_landing.webp" (click)="openLogin('')">
            </div>
            <div class="swiper-slide">
              <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/casino_landing.webp" (click)="openLogin('')">
            </div>
            <div class="swiper-slide">
              <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/racing_landing.webp" (click)="openLogin('')">
            </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6 mb-xs-1">
          <a href="#">
            <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/casino_landing.gif">
          </a>
        </div>
        <div class="col-md-6">
          <a href="#">
            <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/onlinegames_landing.gif">
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- main Slider -->
  <section class="casino-login">
    <div class="container_custom">
      <div class="logincasino-title2">Top Games</div>
      <div class="casino-box mb-1">
        <div class="swiper main-slider">
          <div class="swiper-wrapper">
              <div class="swiper-slide"> <img src="https://speedcdn.io/assets/radheexch-client/topgame1.webp" class=" w-10" alt="..." (click)="openLogin('')"></div>
              <div class="swiper-slide"> <img src="https://speedcdn.io/assets/radheexch-client/topgame2.webp" class=" w-10" alt="..." (click)="openLogin('')"></div>
              <div class="swiper-slide"> <img src="https://speedcdn.io/assets/radheexch-client/topgame3.webp" class=" w-10" alt="..." (click)="openLogin('')"></div>
              <div class="swiper-slide"> <img src="https://speedcdn.io/assets/radheexch-client/topgame4.webp" class=" w-10" alt="..." (click)="openLogin('')"></div>
              <div class="swiper-slide"> <img src="https://speedcdn.io/assets/radheexch-client/topgame5.webp" class=" w-10" alt="..." (click)="openLogin('')"></div>
              <div class="swiper-slide"> <img src="https://speedcdn.io/assets/radheexch-client/topgame6.webp" class=" w-10" alt="..." (click)="openLogin('')"></div>
              <div class="swiper-slide"> <img src="https://speedcdn.io/assets/radheexch-client/topgame7.webp" class=" w-10" alt="..." (click)="openLogin('')"></div>
              <div class="swiper-slide"> <img src="https://speedcdn.io/assets/radheexch-client/topgame8.webp" class=" w-10" alt="..." (click)="openLogin('')"></div>
              <div class="swiper-slide"> <img src="https://speedcdn.io/assets/radheexch-client/topgame9.webp" class=" w-10" alt="..." (click)="openLogin('')"></div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </section>
  <!-- main Slider -->

  <section *ngIf="homeData">
    <div>
      <!-- game start -->
      <div class="col-md-12 px-1" *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;">

        <!-- HOME PAGE -->
        <div class="horse">
          <app-sport-list *ngIf="(events.sports.includes(mn.id))" [list]="homeData" [eventId]="mn.id"
            [eventName]="mn.name" [oddsData]="oddsLisDis"></app-sport-list>
        </div>
        <!-- /HOME PAGE -->

        <app-loader class="no-overlay" *ngIf="isLoad || !homeData"></app-loader>

      </div>
      <!-- game end -->

      <!-- New Hourse Upcomming Races Start -->
      <div class="col-md-12 px-1" *ngIf="router.url.includes('home')">
        <div class="horse">
          <div class="sub_path">
            <p>Horse Racing</p>
          </div>
          <div class="game-wrap py-1 d-flex" *ngIf="hRaceList.length > 0">
            <span class="upcome">Coming Up</span>
            <div class="scroll-container indiana-scroll-container indiana-scroll-container--hide-scrollbars">
              <div style="white-space: nowrap;">
                <ul class="horsedatahome">
                  <li *ngFor="let item of hRaceList;trackBy:trackByIndex;">
                    <a href="javascript:void(0)" routerLink="/event/detail/{{item?.event_id}}/{{item?.market_id}}">
                      <img src="https://speedcdn.io/assets/radheexch-client/icons/horse.svg" class="horsehomeimg" />
                      <!-- <img class="horsehomeimg" src="https://flagcdn.com/h40/{{item?.event_country_code.toLowerCase()}}.png"> -->
                      <span class="mr-1">{{item?.market_start_time_format | date : 'hh:mm a'}}</span>
                      {{item?.event_name}} - {{item?.market_name}}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="game-wrap py-1 d-flex" *ngIf="hRaceList.length == 0">
            There is no upcoming hourse race.
          </div>
        </div>
      </div> <!-- New Hourse Upcomming Races End -->

      <!-- New Greyhound Upcomming Races Start -->
      <div class="col-md-12 px-1" *ngIf="router.url.includes('home')">
        <div class="horse">
          <div class="sub_path">
            <p>Greyhound Racing</p>
          </div>
          <div class="game-wrap py-1 d-flex" *ngIf="gRaceList.length > 0">
            <span class="upcome">Coming Up</span>
            <div class="scroll-container indiana-scroll-container indiana-scroll-container--hide-scrollbars">
              <div style="white-space: nowrap;">
                <ul class="horsedatahome">
                  <li *ngFor="let item of gRaceList;trackBy:trackByIndex;">
                    <a href="javascript:void(0)" routerLink="/event/detail/{{item?.event_id}}/{{item?.market_id}}">
                      <img src="https://speedcdn.io/assets/radheexch-client/icons/horse.svg" class="horsehomeimg" />
                      <!-- <img class="horsehomeimg" src="https://flagcdn.com/h40/{{item?.event_country_code.toLowerCase()}}.png"> -->
                      <span class="mr-1">{{item?.market_start_time_format | date : 'hh:mm a'}}</span>
                      {{item?.event_name}} - {{item?.market_name}}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="game-wrap py-1 d-flex" *ngIf="gRaceList.length == 0">
            There is no upcoming greyhound race.
          </div>
        </div>
      </div> <!-- New Greyhound Upcomming Races End -->
    </div>
  </section>

  <img class="img-fluid" src="https://images.staticcontent.io/rde/login/pg-banner.webp" *ngIf="(env.host.name == 'radhexchange' || env.host.name == 'localhost')">
  <img class="img-fluid" src="assets/img/pg-banner-min.png" *ngIf="env.host.name == 'crex999'">

  <!-- <section class="casino-login">
    <div class="container-fluid">
      <div class="logincasino-title2">Live Casino</div>
      <div class="casino-box">
        <div class="casino-login-grid-container2" style="cursor: pointer;">
          <div class="casino-login-grid-item2" (click)="confirmCasinoDetail(99995, 5079)">
            <img src="https://images.staticcontent.io/rde/loginimages/c1.png" alt="logo" />
          </div>
          <div class="casino-login-grid-item2" (click)="confirmCasinoDetail(99995, 5159)">
            <img src="https://images.staticcontent.io/rde/loginimages/c2.png" alt="logo" />
          </div>
          <div class="casino-login-grid-item2" (click)="confirmCasinoDetail(99995, 5163)">
            <img src="https://images.staticcontent.io/rde/loginimages/c3.png" alt="logo" />
          </div>
          <div class="casino-login-grid-item2" (click)="_common.commingSoon()">
            <img src="https://images.staticcontent.io/rde/loginimages/c4.png" alt="logo" />
          </div>
          <div class="casino-login-grid-item2 mt-7 mb-t-7" (click)="confirmCasinoDetail(99995, 5196)">
            <img src="https://images.staticcontent.io/rde/loginimages/c5.png" alt="logo" />
          </div>
          <div class="casino-login-grid-item2 mt-7 mb-t-7" (click)="confirmCasinoDetail(99995, 5194)">
            <img src="https://images.staticcontent.io/rde/loginimages/c6.png" alt="logo" />
          </div>
          <div class="casino-login-grid-item2 mt-7 mb-t-7" (click)="_common.commingSoon()">
            <img src="https://images.staticcontent.io/rde/loginimages/c7.png" alt="logo" />
          </div>
          <div class="casino-login-grid-item2 mt-7 mb-t-7" (click)="confirmCasinoDetail(99995, 5263)">
            <img src="https://images.staticcontent.io/rde/loginimages/c8.png" alt="logo" />
          </div>
          <div class="casino-login-grid-item2 mt-7 mobile-hide-casinoimg" (click)="confirmCasinoDetail(99995, 5192)">
            <img src="https://images.staticcontent.io/rde/loginimages/c9.png" alt="logo" />
          </div>
          <div class="casino-login-grid-item2 mt-7 mobile-hide-casinoimg" (click)="confirmCasinoDetail(99995, 5175)">
            <img src="https://images.staticcontent.io/rde/loginimages/c10.png" alt="logo" />
          </div>
          <div class="casino-login-grid-item2 mt-7 mobile-hide-casinoimg" (click)="confirmCasinoDetail(99995, 5272)">
            <img src="https://images.staticcontent.io/rde/loginimages/c11.png" alt="logo" />
          </div>
          <div class="casino-login-grid-item2 mt-7 mobile-hide-casinoimg" (click)="confirmCasinoDetail(99995, 7006)">
            <img src="https://images.staticcontent.io/rde/loginimages/c12.png" alt="logo" />
          </div>
        </div>
      </div>
    </div>
  </section> -->

  <footer class="footer_landing">
    <ul class="partner_logo">
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_evolution.png" alt="Evolution">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_ezugi.png" alt="Ezugi">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_pragmatic-live.png" alt="Pragmatic Live">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_betgames.png" alt="Betgames">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_betsoft.png" alt="Betsoft">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_spribe.png" alt="Spribe">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_evoplay.png" alt="Evoplay">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://images.staticcontent.io/casino/banner/loginimages/logo-18plus.svg" alt="+18">
        </a>
      </li>
    </ul>
    <p>You must be over 18 years old, or the legal age at which gambling or gaming activities are allowed under the law or jurisdiction that applies to you. You must reside in a country in which access to online gambling to its residents.</p>
  </footer>

  <div class="footer-menu">
    <div class="wrapper">
        <div class="button-f" [routerLink]="isLogin() ? ['/dashboard'] : ['/home']" routerLinkActive="active">
            <div class="icon"><img src="https://images.staticcontent.io/rde/uimg/home.svg" alt=""></div><span>Home</span></div>
        <div class="button-f" routerLink="/inplay" routerLinkActive="active">
            <div class="icon"><img src="https://images.staticcontent.io/rde/uimg/inplay.svg" alt=""></div><span>Inplay</span></div>
        <div class="button-f" [routerLink]="['/casino', 99999]" routerLinkActive="active">
            <div class="icon"><img src="https://images.staticcontent.io/rde/uimg/mini_games.gif" alt=""></div><span>MiniGame</span></div>
        <div class="button-f" (click)="openLogin('')">
            <div class="icon"><img src="https://images.staticcontent.io/rde/uimg/menu.svg" alt=""></div><span>Menu</span></div>
    </div>
  </div>

</div>
<!-- ======= maina content ======= -->

<ng-template #ruleModal>
  <div class="modal-header">
    <h4 class="modal-title mt-0">18 Plus Rules</h4>
    <button type="button" class="close" (click)="modalRef?.hide()">×</button>
  </div>
  <div class="modal-body">
    <div id="age18" class="">
      <ul style="line-height:30px; font-size:13px;">
        <li>It is illegal for anybody under the age of 18 to gamble</li>
        <li>It is an offence for anyone under the age of 18 to open an account or to gamble on {{env.host.name}}</li>
        <li>{{env.host.name}} takes its age-verification responsibilities very seriously</li>
        <li>We carry out age-verification checks on all customers who use payment mechanisms which are available to
          under 18s and additionally perform random age-verification checks on customers using other forms of funding
          mechanisms</li>
        <li>We may ask for information to verify your age and could restrict or suspend your account until your age is
          confirmed</li>
        <li>{{env.host.name}} advises and encourages its customers to prevent minors from accessing gambling websites.
        </li>
        <li>We encourage parents consider the use of internet use protection tools</li>
        <li>You may find following links useful <a href="https://www.cyberpatrol.com/"
            target="_blank">cyberpatrol.com</a></li>
      </ul>
    </div>
  </div>
</ng-template>
